import { ClientAnalytics } from './clientAnalytics'

// ── Dialog lifecycle ──
type LifecycleEvent =
  | 'workspace_settings:open'
  | 'workspace_settings:close'
  | 'workspace_settings:nav'

// ── Challenge panel (per-challenge) ──
type ChallengeEvent =
  | 'workspace_settings:challenge:weapon_change'

// ── Appearance panel (cross-challenge) ──
type AppearanceEvent =
  | 'workspace_settings:appearance:font_size_change'
  | 'workspace_settings:appearance:theme_change'
  | 'workspace_settings:appearance:tab_style_change'

// ── Behavior panel (cross-challenge) ──
type BehaviorEvent =
  | 'workspace_settings:behavior:autosave_indicator_toggle'
  | 'workspace_settings:behavior:confirm_tab_close_toggle'

export type WorkspaceSettingsAnalyticsEvent =
  | LifecycleEvent
  | ChallengeEvent
  | AppearanceEvent
  | BehaviorEvent

export function trackWorkspaceSettings(
  event: WorkspaceSettingsAnalyticsEvent,
  properties?: Record<string, unknown>
) {
  ClientAnalytics.track(event, properties)
}
